import { retrieveLaunchParams } from '@telegram-apps/sdk-react';

const STORAGE_MINI_APP_KEY = 'telegram-apps/mini-app';
const STORAGE_LAUNCH_PARAMS_KEY = 'telegram-apps/launch-params';

const retrieveTgInitData: () => string | undefined = () => {
  try {
    const miniAppValue = sessionStorage.getItem(STORAGE_MINI_APP_KEY);
    if (miniAppValue) {
      const tar = JSON.parse(miniAppValue)?.initDataRaw;
      if (tar) return tar;
    }

    const launchpadValue = sessionStorage.getItem(STORAGE_LAUNCH_PARAMS_KEY);
    if (launchpadValue) {
      const tar = new URLSearchParams(launchpadValue.replaceAll('"', ''))?.get(
        'tgWebAppData'
      );
      if (tar) return tar;
    }
    return retrieveLaunchParams()?.initDataRaw;
  } catch (error) {
    return retrieveLaunchParams()?.initDataRaw;
  }
};

export default retrieveTgInitData;
